import React, {Component} from 'react'
import IdleTimerContainer from './components/idle/IdleTimerContainer';
import App from './App';
import ScreenSaver from './views/ScreenSaver/ScreenSaver';

class Container extends Component 
{
    render()
    {
        return <div className='h-100'>
                    <IdleTimerContainer></IdleTimerContainer>
                    <App/>
                    <ScreenSaver/>
                </div>
    }
}

export default Container